import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TitleService {
    public titleKey: string = '';
    private separator: string = ' - ';

    constructor(
        private titleService: Title,
        private translocoService: TranslocoService
    ) {
        this.translocoService.langChanges$.subscribe((lang: string) => {
            this.setTitle(this.titleKey);
        });
    }

    setTitle(titleKey: string) {
        this.titleKey = titleKey;

        let lang = this.translocoService.getActiveLang();

        firstValueFrom(this.translocoService.selectTranslation(lang)).then(translations => {
            let newTitle = translations[titleKey];
            let suffix = translations['appname'];

            this.titleService.setTitle(!newTitle || newTitle === suffix ? suffix : `${newTitle}${this.separator}${suffix}`);
        });
    }

    getTitle() {
        return this.titleService.getTitle();
    }
}
